import axios from "../plugins/parseAxios";

export class IncomeApi {
  static createIncome(formData) {
    return axios.post("functions/createIncome", formData);
  }
  static updateIncome(formData) {
    return axios.post("functions/updateIncome", formData);
  }
  static removeIncome(id) {
    return axios.post("functions/removeIncome", { id });
  }
  static getIncome(id) {
    return axios.post("functions/getIncome", { id });
  }
  static getIncomeBetweenDateByMarket(formData) {
    return axios.post("functions/getIncomeBetweenDateByMarket", formData);
  }
}